import BeerSlider from 'beerslider';
import 'beerslider/dist/BeerSlider.css';

import './common';

const slider1 = new BeerSlider(document.getElementById('slider1'));
const slider2 = new BeerSlider(document.getElementById('slider2'));
